import TextareaInput from '../../TextareaInput'
import FormLayout from '../FormLayout'
import { IResolvedWithReportinhPartyForm } from './types'

const ResolvedWithReportingPartyForm: React.FC<IResolvedWithReportinhPartyForm> = ({
  register,
  errorDescription = '',
  errorResponse = '',
}) => {
  return (
    <FormLayout>
      <TextareaInput
        label='What was the issue or question?'
        minRows={5}
        placeholder='Briefly describe the issue that was reported.'
        register={register}
        fieldName={'issueDescription'}
        error={errorDescription}
      />
      <TextareaInput
        label='What was the response?'
        minRows={5}
        placeholder='Briefly describe the response to the reporting party.'
        register={register}
        fieldName={'response'}
        error={errorResponse}
      />
    </FormLayout>
  )
}

export default ResolvedWithReportingPartyForm
